/* eslint-disable spire/export-styles */
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    pageTitle: getCurrentPage(state).fields.title,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface PageTitleStyles {
    pageTitleStyle: InjectableCss
}
export const PageTitleStyles: PageTitleStyles = {
    pageTitleStyle: {
        css: css`
             background: linear-gradient(180deg,rgba(255,255,255,0) 50%, #efefef 50%);
             max-width: fit-content;
        `
    }
}

const PageTitle: React.FunctionComponent<Props> = ({ pageTitle, fields }: Props) =>{ 
    return(
    <Typography variant="h2" as="h1" data-test-selector="PageTitle" {...PageTitleStyles.pageTitleStyle}>
        {fields.overrideTitle || pageTitle}
    </Typography>
)};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(PageTitle),
    definition: {
        group: "Basic",
        icon: "heading",
    },
};

export default widgetModule;
